var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"inherit"}},[(_vm.urlViewer)?_c('b-embed',{attrs:{"type":"iframe","src":_vm.urlViewer,"allowfullscreen":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }